<nav class="navbar navbar-expand-lg navbar-light fixed-top" id="mainNav">
    <div class="container" style="color: black;">
        <a style="color: black;" href="./index.html">Home</a>
        <!-- <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse"
            data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false"
            aria-label="Toggle navigation">
            Menu
            <i class="fas fa-bars"></i>
        </button> -->
        <!-- <div class="collapse navbar-collapse" id="navbarResponsive">
            <ul class="navbar-nav ml-auto">
                <li class="nav-item"><a class="nav-link js-scroll-trigger" href="./index.html">A propos</a></li>
            </ul>
        </div> -->
    </div>
</nav>

<section class="text-center" id="cgu">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 mx-auto">
                <h2 class="text-white mb-4">Utiliser l'application</h2>
                <div class="main-page-wrapper">

                    <!-- <%- include('_header'); %> -->

                    <div class="solid-inner-banner">
                        <h1 class="page-title">Protection des données</h1>
                    </div> <!-- /.solid-inner-banner -->

                    <!-- Page Content-->
                    <div class="container">
                        <h1>Règles de protection des données et confidentialité</h1>
                        <p>
                            Lors de votre visite sur notre application, nous sommes ammenés à collecter certaines
                            données à votre sujet, en conformité au <a
                                href="http://eur-lex.europa.eu/legal-content/FR/TXT/?uri=CELEX:32016R0679"
                                target="_blank">règlement européen 2016/679, dit « règlement général sur la protection
                                des données »</a>.<br />
                            Cette politique de protection des données basée sur des élèments clairement détaillés a pour
                            objectif de vous apporter des informations en toute transparence permettant un interaction
                            basé sur la confiance et la sécurité.

                            Les informations présentées sont :
                        <ul>
                            <li>
                                Les conditions de la collecte de ces données 
                            </li>
                            <li>
                                Le traitement de ces données
                            </li>
                            <li>
                                Le protection de ces données
                            </li>
                            <li>
                                La gestion de ces données
                            </li>
                        </ul>
                        <em>Dernière mise à jour : 24 mai 2018.</em>
                        <br>
                        <h2>Collectes des données lors des visites</h2>
                        <p>
                            Lors de votre visite, nous enregistrons les données suivantes dans une base de données:
                            <!-- <ul>
                            <li>
                                Votre adresse IP
                            </li>
                            <li>
                                La date et l’heure de votre visite
                            </li>
                            <li>
                                La référence des pages visitées
                            </li>
                            <li>
                                Le code de suivi partenaire
                            </li>
                        </ul> -->
                            Ces données ont pour but de mesurer l'audiance et les pages visitées, éventuellement pouvoir
                            rémunérer un apporteur d'affaire et les éventuelles anomalies rencontrées lors de la visite.
                            Nous traitons vos informations personnelles afin d'opérer, de fournir et d'améliorer les
                            Services <br />
                            Ces données sont conservées 12 mois.
                        </p>
                        <br>
                        <h2>Collectes des données lors d'un abonnement</h2>
                        <!-- <p>
                            Lors d'une connexion, nous enregistrons les données suivantes dans une base de données:
                        <ul>
                            <li>
                                Votre adresse IP
                            </li>
                            <li>
                                Les données de connexion, les adresses e-mail
                            </li>
                            <li>
                                Les données de vos profil issu de nos partenaires Google et Facebook.
                            </li>
                        </ul>


                        <ul>
                            <li>
                                <strong>Fourniture des services</strong>
                                <p>
                                    Nous utilisons vos informations personnelles aux fins d'enregistrement, de
                                    fourniture et de gestion des services, de communication avec vous en relation avec
                                    votre souscription, les services et nos offres promotionnelles.
                                    Les données sont transmises pour des besoins connexes de façon sécurisé à nos
                                    partenaires .
                                </p>
                            </li>
                            <li>
                                <strong>Fourniture, résolution des problèmes et amélioration des Services</strong>
                                <p>
                                    Nous utilisons vos informations personnelles pour vous fournir des fonctionnalités,
                                    analyser des performances, corriger les erreurs et améliorer l'accessibilité et
                                    l'efficacité des Services.
                                </p>
                            </li>
                            <li>
                                <strong>Nous conformer à nos obligations légales</strong>
                                <p>
                                    Dans certains cas, nous avons une obligation légale de collecter et traiter vos
                                    informations personnelles.
                                </p>
                            </li>
                            <li>
                                <strong>Communiquer avec vous</strong>
                                <p>
                                    Nous utilisons vos informations personnelles afin de communiquer avec vous au sujet
                                    des Services via différents canaux (ex. email).
                                </p>
                            </li>
                            <li>
                                <strong>Finalités pour lesquelles nous recueillons votre consentement</strong>
                                <p>
                                    Nous pourrons également être amenés à requérir votre consentement pour le traitement
                                    de vos informations personnelles pour une finalité spécifique que nous vous
                                    indiquerons. Lorsque vous consentez au traitement de vos informations personnelles
                                    pour cette finalité spécifique, vous pourrez retirer votre consentement à tout
                                    moment et nous cesserons tout traitement de vos informations pour cette finalité.
                                </p>
                            </li>
                        </ul>
                        </p> -->
                        <!-- <h2>Collectes des données lors d'un chat</h2>
                            <p>
                            Lors de votre visite, nous enregistrons les données suivantes dans une base de données:
                            <ul>
                                <li>
                                    Votre adresse IP
                                </li>
                                <li>
                                    La date et l’heure de votre visite
                                </li>
                                <li>
                                    La référence des pages visitées
                                </li>
                                <li>
                                    Votre nom et votre prénom
                                </li>
                                <li>
                                    Votre adresse email
                                </li>
                            </ul>
                            Ces informations nous servent à vous guider sur nos offres ou dans un formulaire, pouvoir vous recontacter le cas échéant.<br />
                            Ces données sont conservées 12 mois.
                            </p> -->

                        <h2>Vos données personnelles sont-elles protégées</h2>
                        <p>
                            Notre application est conçu avec un souci de protection de la sécurité.<br />
                            Nous protégeons la sécurité de vos informations personnelles lors de leur transmission en
                            utilisant le logiciel SSL (Secure Sockets Layer Software) qui crypte les informations que
                            vous entrez avant qu'elles ne nous soient envoyées.<br />
                            Nous maintenons des mesures de sécurité physiques, électroniques et des procédures de
                            sauvegarde en rapport avec la collecte, la conservation et la communication d'informations
                            personnelles de clients. Nos procédures de sécurité peuvent nous amener à vous demander une
                            preuve de votre identité avant de pouvoir vous communiquer vos informations personnelles.
                        </p>
                        <p>
                            Nous travaillons exclusivement avec des prestataires de qualité tels que Google, Facebook et
                            Apple. Nous vérifions régulièrement les pratiques de nos partenaires, afin de nous assurer
                            qu’ils respectent bien le règlement européen 2016/679, et nous engageons à rompre nos
                            relations avec ceux qui ne le feraient pas.
                        </p>
                        <h2>À quelles informations puis-je avoir accès ?</h2>
                        <p>
                            Vous avez accès à vos informations, incluant votre nom, votre adresse.
                            Conformément à la loi informatique et libertés du 6 janvier 1978 modifiée, vous disposez
                            d'un droit d'accès, d'information et, si justifié, de rectification pour toutes les
                            informations vous concernant. Vous pouvez exercer ce droit à tout moment en nous contactant
                            à l'adresse suivante : contact@seeku.io<br>
                            <br />
                            Vous pourrez alors :
                        </p>
                        <div class="row">
                            <div class="col col-2">
                                <span class="fa fa-copy fa-3x"></span>
                            </div>
                            <div class="col">
                                Obtenir une copie de vos données
                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-2">
                                <span class="fa fa-check-circle fa-3x"></span>
                            </div>
                            <div class="col">
                                Corriger vos données
                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-2">
                                <span class="fa fa-trash fa-3x"></span>
                            </div>
                            <div class="col">
                                Supprimer vos données
                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-2">
                                <span class="fa fa-truck fa-3x"></span>
                            </div>
                            <div class="col">
                                Droit à la portabilité des données
                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-2">
                                <span class="fa fa-cog fa-3x"></span>
                            </div>
                            <div class="col">
                                Droit de limitation ou d'opposition au traitement des données
                            </div>
                        </div>
                        <br />
                        <h2>Politique de sécurité en cas de faille de sécurité</h2>
                        <!-- <p>
                        <h2>En cas de problèmes de sécurité nous contacterons la CNIL, prestataires, partenaires et
                            internautes concernés sous 48h.</h2>
                        </p> -->
                        <h2>Cookies</h2>
                        <p>
                            Un cookie est un espace de stockage d'information situé dans votre navigateur, il permet de
                            conserver des données d’une visite à l’autre, pour diverses raisons. :
                        <ul>
                            <li>
                                Dans notre cas nous utilisons uniquement des cookies de mesure de d'audience.
                            </li>
                        </ul>
                        La durée de vie de ces cookies ne dépasse pas 12 mois.<br />
                        <!-- Vous pouvez refuser l’enregistrement de tous les cookies dans les réglages de votre navigateur, auquel cas certaines fonctions de nos sites et services seront inopérantes. Vous pouvez sinon personnaliser l’enregistrement des cookies de nos partenaires (et d’autres cookies) à l’aide des liens suivants :<br />
                            <ul>
                                <li>
                                    <a href="https://tools.google.com/dlpage/gaoptout" target="_blank">Google Analytics</a>
                                </li>
                            </ul>
                            </p> -->

                        <h2>Transfert des données</h2>
                        <p>Certaines des données que nous collectons sont transmises à nos partenaires :</p>
                        <p>Nous avons sélectionné nos partenaires respectueux des normes Data privacy & GDPR</p>
                        <ul>
                            <li>
                                <a href="https://policies.google.com/privacy?hl=en" target="_blank">Google</a>
                            </li>
                            <li>
                                <a href="https://facebook.fr" target="_blank">Facebook</a>
                            </li>
                            <li>
                                <a href="https://apple.com" target="_blank">Apple</a>
                            </li>
                        </ul>

                        <h2>Abonnement « receip2go» .</h2>
                        <p>Forfaits: accès en illimité à l'application et sans publicité</p>
                        <ul>
                            <li>Forfait mensuel : 7,99 €</li>
                            <li>Forfait annuel : 78,99 €</li>
                        </ul>
                        <p>Paiements et renouvellement :</p>
                        <ul>
                            <li>
                                Le paiement sera débité du compte iTunes lors de la confirmation de l'achat. L'abonnement se
                        renouvelle automatiquement à moins que le renouvellement automatique ne soit désactivé au moins
                        24 heures avant la fin de la période en cours.
                            </li>
                            <li>
                                Le compte sera facturé pour le renouvellement dans les 24 heures avant la fin de la période en
                                cours.
                            </li>
                            <li>
                                Vous pouvez gérer ou désactiver le renouvellement automatique dans les paramètres de votre
                                compte à tout moment après l'achat.
                            </li>
                            <li>
                                Aucune résiliation de l'abonnement en cours n'est autorisée pendant la période active.
                            </li>
                        </ul>

                        <!-- <ul>
                            <li>
                                Les abonnements auto-renouvelables sont disponibles sur l'App Store pour receipt2go.
                            </li>
                            <li>
                                Le paiement sera débité de votre compte iTunes lors de la confirmation de l'achat et sera automatiquement renouvelé (à la durée/au prix sélectionné) sauf si le renouvellement automatique est désactivé à au moins 24 heures avant la fin de la période en cours.
                            </li>
                            <li>
                                Le compte sera facturé pour le renouvellement dans les 24 heures avant la fin de la période en cours.
                            </li>
                            <li>
                                L'abonnement actuel ne peut pas être annulé pendant la période d'abonnement active ; cependant, vous pouvez gérer votre abonnement et/ou désactiver le renouvellement automatique en visitant les paramètres de votre compte iTunes après l'achat.
                            </li>
                            <li>
                                Toute portion inutilisée de la période initiale gratuite d'un mois sera perdue lorsque vous achetez un abonnement.
                            </li>
                            <li>
                                Veuillez sélectionner l'une des les abonnements auto-renouvelables ci-dessous.
                            </li>
                        </ul> -->


                    </div>
                </div>
                <!-- <p class="text-white-50">
                    Receipt2Go est une application mobile sur ios et android.
                    Aprés avoir enregistré un bailleur, un locataire et une location vous pouvez générer vos quittances en 30 secondes chaque mois.
                    Et ensuite vous pouvez l'envoyer par mail a votre locataire.
                </p> -->
            </div>
        </div>
        <!-- <img class="img-fluid" src="assets/img/ipad.png" alt="" /> -->
    </div>
</section>
<section class="contact-section bg-black">
    <div class="container">
        <div class="row">
            <div class="col-md-4 mb-3 mb-md-0">
                <!-- <div class="card py-4 h-100">
                    <div class="card-body text-center">
                        <i class="fas fa-map-marked-alt text-primary mb-2"></i>
                        <h4 class="text-uppercase m-0">Address</h4>
                        <hr class="my-4" />
                        <div class="small text-black-50">4923 Market Street, Orlando FL</div>
                    </div>
                </div> -->
            </div>
            <div class="col-md-4 mb-3 mb-md-0">
                <div class="card py-4 h-100">
                    <div class="card-body text-center">
                        <i class="fas fa-envelope text-primary mb-2"></i>
                        <h4 class="text-uppercase m-0">Email</h4>
                        <hr class="my-4" />
                        <div class="small text-black-50"><a href="#!">receipt2go.contact@gmail.com</a></div>
                    </div>
                </div>
            </div>
            <div class="col-md-4 mb-3 mb-md-0">
                <!-- <div class="card py-4 h-100">
                    <div class="card-body text-center">
                        <i class="fas fa-mobile-alt text-primary mb-2"></i>
                        <h4 class="text-uppercase m-0">Phone</h4>
                        <hr class="my-4" />
                        <div class="small text-black-50">+1 (555) 902-8832</div>
                    </div>
                </div> -->
            </div>
        </div>
        <div class="social d-flex justify-content-center">
            <!-- <a class="mx-2" href="#!"><i class="fab fa-twitter"></i></a>
            <a class="mx-2" href="#!"><i class="fab fa-facebook-f"></i></a> -->
            <!-- <a class="mx-2" href="#!"><i class="fab fa-github"></i></a> -->
        </div>
    </div>
</section>